import MTabs from './MTabs';
export default MTabs;
